import React from "react";
import TablaVentaProductoCodificado from "js/components/TablaVentaProductoCodificado";

function VentaProductoCodificado(props) {
  return <TablaVentaProductoCodificado />;
}

export default VentaProductoCodificado;
